
export const defaultTarjetasEmergencia = () => {
  return {
    editar: false,
    id_modelo: '',
    encabezado_pie_pagina: false,
    encabezado: '',
    pie_pagina: '',
  }
}

export default {
    modelos: [],
    selectedTarjetasEmergencia: defaultTarjetasEmergencia()
}
